import { Howler } from 'howler'

const BGMSound = new Howl({
  src: ["/assets/pixi/plinko-game/audios/BGM.mp3"],
  loop: true
})

const leftDropSound = new Howl({
  src: ["/assets/pixi/plinko-game/audios/Left-Drop.wav"],
  loop: false
})

const rightDropSound = new Howl({
  src: ["/assets/pixi/plinko-game/audios/Right-Drop.wav"],
  loop: false
})

const orangeBoxSound = new Howl({
  src: ["/assets/pixi/plinko-game/audios/Orange-Box.wav"],
  loop: false
})

const redBoxSound = new Howl({
  src: ["/assets/pixi/plinko-game/audios/Red-Box.wav"],
  loop: false
})

const yellowBoxSound = new Howl({
  src: ["/assets/pixi/plinko-game/audios/Yellow-Box.wav"],
  loop: false
})

export function playBGMSound () {
  BGMSound?.play();
}
export function stopBGMSound () {
  BGMSound?.pause();
}
export function playRightDropSound () {
  rightDropSound?.play();
}
export function playLeftDropSound () {
  leftDropSound?.play();
}
export function playYellowBoxSound () {
  yellowBoxSound?.play();
}
export function playOrangeBoxSound () {
  orangeBoxSound?.play();
}
export function playRedBoxSound () {
  redBoxSound?.play();
}

// let BGMSource, rightDropSource, leftDropSource, yellowBoxSource, orangeBoxSource, redBoxSource;
// import { path } from "./settings.js";

// export function loadSounds () {

//   BGMSource = PIXI.sound.Sound.from(path.audioPath + 'BGM.mp3');
//   rightDropSource = PIXI.sound.Sound.from(path.audioPath + 'Right-Drop.wav');
//   leftDropSource = PIXI.sound.Sound.from(path.audioPath + 'Left-Drop.wav');
//   yellowBoxSource = PIXI.sound.Sound.from(path.audioPath + 'Yellow-Box.wav');
//   orangeBoxSource = PIXI.sound.Sound.from(path.audioPath + 'Orange-Box.wav');
//   redBoxSource = PIXI.sound.Sound.from(path.audioPath + 'Red-Box.wav');

//   console.log("Audio Loaded");
// }

// export function playBGMSound () {
//   BGMSource.play();
// }
// export function stopBGMSound () {
//   BGMSource.pause();
// }
// export function playRightDropSound () {
//   rightDropSource.play();
// }
// export function playLeftDropSound () {
//   leftDropSource.play();
// }
// export function playYellowBoxSound () {
//   yellowBoxSource.play();
// }
// export function playOrangeBoxSound () {
//   orangeBoxSource.play();
// }
// export function playRedBoxSound () {
//   redBoxSource.play();
// }


// export function VolumeController (v) {
//   BGMSource.volume = v
//   rightDropSource.volume = v
//   leftDropSource.volume = v
//   yellowBoxSource.volume = v
//   orangeBoxSource.volume = v
//   redBoxSource.volume = v
// }
